var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20442_36556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99883 15.9977C12.4165 15.9977 15.9977 12.4165 15.9977 7.99883C15.9977 3.5812 12.4165 0 7.99883 0C3.5812 0 0 3.5812 0 7.99883C0 12.4165 3.5812 15.9977 7.99883 15.9977Z",
    fill: "#7E57C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71757 3.98828H11.4626V12.3738H4.53711V3.98828H4.71757ZM7.45259 4.9023H10.3681V5.26556H7.45259V4.89761V4.9023ZM7.45259 5.81163H9.45874V6.17724H7.45259V5.81163ZM7.45259 7.45217H10.3681V7.81778H7.45259V7.45217ZM7.45259 8.36385H9.45874V8.72711H7.45259V8.36385ZM7.45259 10.0044H10.3681V10.3677H7.45259V10.0044ZM7.45259 10.9161H9.45874V11.2793H7.45259V10.9161ZM5.62924 11.2793H6.54326V10.3677H5.62924V11.2793ZM6.72372 11.6449H5.26598V10.0044H6.90652V11.6449H6.72372ZM5.62924 8.72711H6.54326V7.81778H5.62924V8.72711ZM6.72372 9.09272H5.26598V7.45217H6.90652V9.09272H6.72372ZM5.62924 6.17724H6.54326V5.26322H5.62924V6.17724ZM6.72372 6.5405H5.26598V4.89996H6.90652V6.5405H6.72372Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20442_36556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.7cf34f22a665bf3dc3863e22ffbe8b0a.svg";
export { ForwardRef as ReactComponent };